// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Storefront40FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Storefront40Filled: FC<Storefront40FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M35.014 18.389v13.833c0 .75-.276 1.4-.827 1.952-.55.55-1.2.826-1.95.826H7.763c-.75 0-1.4-.275-1.951-.826-.551-.551-.827-1.202-.827-1.952V18.39A4.98 4.98 0 0 1 3.466 16c-.283-.954-.267-1.935.048-2.945l1.778-5.638c.222-.741.613-1.33 1.173-1.764A3.07 3.07 0 0 1 8.403 5h23.083c.769 0 1.44.22 2.014.66.574.44.977 1.025 1.208 1.757l1.806 5.638c.315 1.01.326 1.987.035 2.931a5.256 5.256 0 0 1-1.535 2.403Zm-11.278-1.444c.787 0 1.43-.262 1.93-.785.5-.524.7-1.142.598-1.855l-1-6.527h-3.861v6.639c0 .675.222 1.266.667 1.77.444.505 1 .758 1.666.758Zm-7.694 0c.731 0 1.345-.248 1.84-.744.495-.495.743-1.09.743-1.784v-6.64h-3.861l-1 6.528c-.111.704.067 1.32.535 1.848.467.528 1.048.792 1.743.792Zm-7.528 0c.61 0 1.141-.213 1.59-.64.45-.425.716-.953.799-1.583l1.027-6.944H8.07l-1.834 5.917c-.24.759-.136 1.49.313 2.194s1.104 1.056 1.965 1.056Zm22.972 0c.861 0 1.523-.348 1.986-1.042.463-.694.57-1.43.32-2.208L31.93 7.778h-3.833l1.028 6.944c.083.63.35 1.158.799 1.583.449.427.97.64 1.562.64Z" />
        </svg>
    );
};

export default Storefront40Filled;
